module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "400px"
    }
  }, [_c('div', {
    staticClass: "foo",
    staticStyle: {
      "float": "left",
      "width": "70%"
    }
  }, [_c('H1', [_vm._v("Porudžbine")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Za dan: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Za dan: ",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "change": _vm.changedDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "50%",
      "border-radius": "10px",
      "margin": "20px",
      "background": "white",
      "color": "#1a1a1a"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container-buttons"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "25%"
    }
  }, [_c('button', {
    staticClass: "module-admin",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleAdminStyle(0)),
    on: {
      "click": function($event) {
        return _vm.setTab(0)
      }
    }
  }, [_c('span', {
    staticClass: "module-center-admin"
  }, [_vm._v("Aktivne  "), (_vm.companyCount > 0) ? _c('b', {
    staticStyle: {
      "background": "#d33",
      "padding": "8px",
      "border-radius": "100px"
    }
  }, [_vm._v(_vm._s(_vm.companyCount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "40%"
    }
  }, [_c('button', {
    staticClass: "module-admin",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleAdminStyle(1)),
    on: {
      "click": function($event) {
        return _vm.setTab(1)
      }
    }
  }, [_c('span', {
    staticClass: "module-center-admin"
  }, [_vm._v("Nedodeljene")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "55%"
    }
  }, [_c('button', {
    staticClass: "module-admin",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleAdminStyle(2)),
    on: {
      "click": function($event) {
        return _vm.setTab(2)
      }
    }
  }, [_c('span', {
    staticClass: "module-center-admin"
  }, [_vm._v("Završene")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "70%"
    }
  }, [_c('button', {
    staticClass: "module-admin",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleAdminStyle(3)),
    on: {
      "click": function($event) {
        return _vm.setTab(3)
      }
    }
  }, [_c('span', {
    staticClass: "module-center-admin"
  }, [_vm._v("Po kompaniji")])])])]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Ukupan broj dostava: "), _c('b', [_vm._v(_vm._s(_vm.tabIndex === 0 || _vm.tabIndex === 1 ? _vm.activeOrders.filter(function (item) { return item.createdBy.id !== '63c6fe4d8e46e43adc260862'; }).length : _vm.finishedOrders.filter(function (item) { return item.createdBy.id !== '63c6fe4d8e46e43adc260862'; }).length))])])]), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newestOrders),
      expression: "newestOrders"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.newestOrders) ? _vm._i(_vm.newestOrders, null) > -1 : (_vm.newestOrders)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newestOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newestOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newestOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newestOrders = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.isAdmin()) ? _c('div', _vm._l((_vm.dispatchersCount.filter(function (e) { return e.count > 0; })), function(item) {
    return _c('span', {
      staticStyle: {
        "color": "cornflowerblue"
      }
    }, [_c('b', [_vm._v("[ " + _vm._s(item.name) + " - "), _c('i', {
      staticStyle: {
        "color": "#FFF"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" ]")]), _vm._v("   \n                    ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', [_c('b', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Legenda: ")]), _vm._v(" \n                      "), _c('b', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v("(L) - kreirao lokal (" + _vm._s(_vm.countLegends.l) + ")")]), _vm._v(" \n                      "), _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(D) - kreirao dispečer (" + _vm._s(_vm.countLegends.d) + ")")]), _vm._v(" \n                      "), _c('b', {
    staticStyle: {
      "color": "cornflowerblue"
    }
  }, [_vm._v("(I) - kreirano preko integracije (" + _vm._s(_vm.countLegends.i) + ")")]), _vm._v(" \n                      "), _c('b', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("(A) - kreirao admin (" + _vm._s(_vm.countLegends.a) + ")")])]), _vm._v(" "), (_vm.isAdmin() && _vm.tabIndex === 2) ? _c('div', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Vreme kašnjenja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeToLate),
      expression: "timeToLate"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "100px",
      "border-radius": "10px",
      "margin": "20px",
      "background": "white",
      "color": "#1a1a1a"
    },
    attrs: {
      "type": "number",
      "placeholder": "Vreme kasnjenja",
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.timeToLate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timeToLate = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin() && _vm.tabIndex === 2) ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyLateOrders),
      expression: "showOnlyLateOrders"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox3",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyLateOrders) ? _vm._i(_vm.showOnlyLateOrders, null) > -1 : (_vm.showOnlyLateOrders)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showOnlyLateOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyLateOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyLateOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyLateOrders = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isLoadingTabOrder) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "margin-left": "36px",
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "10%"
    }
  }, [_c('ul', _vm._l((_vm.drivers), function(item, index) {
    return (index <= 8) ? _c('li', {
      staticStyle: {
        "color": "white",
        "text-align": "left",
        "font-size": "1.8vh"
      }
    }, [_c('p', {
      style: (_vm.getCourierNotMoveStyle(item))
    }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.activeOrders)), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "grey"
      }
    }, [_vm._v(" - " + _vm._s(item.finishedOrders))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "1.3vh",
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(item.lastAddress))])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "10%"
    }
  }, [_c('ul', _vm._l((_vm.drivers), function(item, index) {
    return (index > 8 && index <= 15) ? _c('li', {
      staticStyle: {
        "color": "white",
        "text-align": "left",
        "font-size": "1.8vh"
      }
    }, [_c('p', {
      style: (_vm.getCourierNotMoveStyle(item))
    }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.activeOrders) + " "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "grey"
      }
    }, [_vm._v(" - " + _vm._s(item.finishedOrders))])]), _vm._v(" "), (item.lastAddress !== '') ? _c('div', [_c('p', {
      staticStyle: {
        "font-size": "1.3vh",
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(item.lastAddress))])]) : _vm._e()]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "10%"
    }
  }, [_c('ul', _vm._l((_vm.drivers), function(item, index) {
    return (index > 15) ? _c('li', {
      staticStyle: {
        "color": "white",
        "text-align": "left",
        "font-size": "1.8vh"
      }
    }, [_c('p', {
      style: (_vm.getCourierNotMoveStyle(item))
    }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.activeOrders)), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "color": "grey"
      }
    }, [_vm._v(" - " + _vm._s(item.finishedOrders))])]), _vm._v(" "), _c('div', [_c('p', {
      staticStyle: {
        "font-size": "1.3vh",
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(item.lastAddress))])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.tabIndex === 3) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredOrdersByCompany), function(item) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v(_vm._s(item[1]))])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.tabIndex !== 3) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [(_vm.visibleDevelop()) ? _c('th', {
    staticStyle: {
      "width": "400px",
      "color": "white"
    }
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px",
      "color": "white"
    }
  }, [_vm._v("Restoran")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Vreme preuzimanja")]), _vm._v(" "), (_vm.tabIndex === 2) ? _c('th', {
    staticStyle: {
      "width": "170px",
      "color": "white"
    }
  }, [_vm._v("Pokupljeno")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px",
      "color": "white"
    }
  }, [_vm._v("Adresa")]), _vm._v(" "), (_vm.tabIndex === 0) ? _c('th', {
    staticStyle: {
      "width": "170px",
      "color": "white"
    }
  }, [_vm._v("Kucni br.")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "color": "white"
    }
  }, [_vm._v("Vozač")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px",
      "color": "white"
    }
  }, [_vm._v("Komentar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px",
      "color": "white"
    }
  }, [_vm._v("Status")]), _vm._v(" "), (_vm.tabIndex < 2) ? _c('th', {
    staticStyle: {
      "width": "180px",
      "color": "white"
    }
  }, [_vm._v("Preporuka")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex === -1) ? _c('th', {
    staticStyle: {
      "width": "180px",
      "color": "white"
    }
  }, [_vm._v("Prihvati")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex === -1) ? _c('th', {
    staticStyle: {
      "width": "180px",
      "color": "white"
    }
  }, [_vm._v("Odbij")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex === 0) ? _c('th', {
    staticStyle: {
      "width": "180px",
      "color": "white"
    }
  }, [_vm._v("Kreiraj")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.tabIndex === 0) ? _c('tr', [(_vm.selectedCompany === '') ? _c('td', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('autocompleteObject', {
    attrs: {
      "suggestions": _vm.restaurants,
      "placeholder": _vm.placeholderCompany
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newSelectedCompany = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedCompany !== '') ? _c('td', [_c('div', {
    staticStyle: {
      "color": "white",
      "font-size": "1.2em"
    }
  }, [_c('i', {
    staticClass: "ti-location-pin"
  }), _vm._v(_vm._s(_vm.selectedCompany) + "\n                            "), _c('button', {
    staticClass: "button-small button-outline",
    staticStyle: {
      "background": "#843534"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSelectedRest()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "input-icons"
  }, [_c('i', {
    staticClass: "ti-alarm-clock icon",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.openTimeChooser()
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrder.time),
      expression: "newOrder.time"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background": "white",
      "color": "#1a1a1a",
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "placeholder": "Vreme",
      "name": "time"
    },
    domProps: {
      "value": (_vm.newOrder.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrder, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.visibleChooseTime) ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "close-on-complete": "",
      "auto-scroll": "",
      "drop-direction": "auto"
    },
    on: {
      "input": _vm.changeTime
    },
    model: {
      value: (_vm.choosedTime),
      callback: function($$v) {
        _vm.choosedTime = $$v
      },
      expression: "choosedTime"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.newStreetObject != null && _vm.newStreetObject !== '') ? _c('td', [_c('div', {
    staticStyle: {
      "color": "white",
      "font-size": "1.2em"
    }
  }, [_c('i', {
    staticClass: "ti-location-pin"
  }), _vm._v(_vm._s(_vm.newStreetObject.name) + "\n                            "), _c('button', {
    staticClass: "button-small button-outline",
    staticStyle: {
      "background": "#843534"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSelectedStreet()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.newStreetObject == null || _vm.newStreetObject === '') ? _c('td', [_c('autocompleteAddress', {
    attrs: {
      "suggestions": _vm.streets,
      "placeholder": _vm.placeholderStreet
    },
    on: {
      "update:selectedModel": function($event) {
        _vm.newStreetObject = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabIndex === 0) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.homeNumber),
      expression: "homeNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background": "white",
      "color": "#1a1a1a"
    },
    attrs: {
      "type": "text",
      "placeholder": "Kucni br.",
      "name": "number"
    },
    domProps: {
      "value": (_vm.homeNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.homeNumber = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedDriver === '') ? _c('td', [_c('autocompleteObject', {
    attrs: {
      "suggestions": _vm.drivers,
      "placeholder": _vm.placeholderDriver
    },
    on: {
      "update:selectedModel": function($event) {
        return _vm.setNewDriver($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedDriver !== '') ? _c('td', [_c('div', {
    staticStyle: {
      "color": "white",
      "font-size": "1.2em"
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(_vm._s(_vm.selectedDriver) + "\n                            "), _c('button', {
    staticClass: "button-small button-outline",
    staticStyle: {
      "background": "#843534"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSelectedDriver()
      }
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrder.price),
      expression: "newOrder.price"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background": "white",
      "color": "#1a1a1a",
      "text-align": "center",
      "margin-top": "10px"
    },
    attrs: {
      "type": "number",
      "placeholder": "Cena",
      "name": "cena"
    },
    domProps: {
      "value": (_vm.newOrder.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrder, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "8px"
    }
  }), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payByCredit),
      expression: "payByCredit"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox1",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.payByCredit) ? _vm._i(_vm.payByCredit, null) > -1 : (_vm.payByCredit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.payByCredit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.payByCredit = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.payByCredit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.payByCredit = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.selectedDiscount > 0 && _vm.selectedCompany !== '') ? _c('span', [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("- " + _vm._s(_vm.selectedDiscount) + " RSD")])]) : _vm._e()])])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrder.comment),
      expression: "newOrder.comment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background": "white",
      "color": "#1a1a1a",
      "resize": "none",
      "height": "36px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Komentar",
      "name": "komentar"
    },
    domProps: {
      "value": (_vm.newOrder.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrder, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "name": "dodaj",
      "value": _vm.addTitle,
      "disabled": _vm.isDisabledAddButton
    },
    on: {
      "click": function($event) {
        return _vm.addOrder()
      }
    }
  }), _vm._v(" "), (_vm.visibleScheduleTimer) ? _c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "close-on-complete": "",
      "auto-scroll": "",
      "drop-direction": "auto"
    },
    model: {
      value: (_vm.scheduledTimeOrder),
      callback: function($$v) {
        _vm.scheduledTimeOrder = $$v
      },
      expression: "scheduledTimeOrder"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredOrders), function(order, name, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [(_vm.visibleDevelop()) ? _c('td', [_vm._v(_vm._s(order.id))]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (_vm.styleForNewCompany(order))
    }, [(order.status === 'REJECTED' || order.status === 'DELIVERED') ? _c('b', [_vm._v(_vm._s(_vm.filteredOrders.length - name) + ".")]) : _vm._e(), _vm._v(" " + _vm._s(order.company.internalName) + " "), _c('b', {
      style: (_vm.getCreatorStyle(order))
    }, [_vm._v(_vm._s(_vm.getCreator(order)))])]), _vm._v(" "), _c('td', {
      style: (_vm.checkIfLate(order))
    }, [_c('b', [_vm._v(_vm._s(_vm.formatDateToTime(new Date(order.timestamp + order.preparationTime * 60000))))]), _vm._v(" "), _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.openEditModal(order)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })])]), _vm._v(" "), (_vm.tabIndex === 2) ? _c('td', [_c('b', [_vm._v(_vm._s(order.pickedUpTime != null ? _vm.formatDateToTime(new Date(order.pickedUpTime)) : ''))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.address.street) + "," + _vm._s(order.address.city))]), _vm._v(" "), (_vm.tabIndex === 0) ? _c('td', [_vm._v(_vm._s(_vm.getNumberFromStreet(order.address.street)))]) : _vm._e(), _vm._v(" "), (_vm.getCourierName(order) != null || order.status === 'REJECTED' || order.status === 'DELIVERED') ? _c('td', [_vm._v(_vm._s(_vm.getCourierName(order)) + " "), (order.status !== 'DELIVERED' && order.status !== 'REJECTED') ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.reasignDriver(order.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-close"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getCourierName(order) == null && order.status !== 'REJECTED' && order.status !== 'DELIVERED') ? _c('td', [(order.status !== 'REQUESTED') ? _c('autocompleteObject', {
      attrs: {
        "suggestions": _vm.getMapDrivers(order),
        "placeholder": _vm.placeholderDriver
      },
      on: {
        "update:selectedModel": function($event) {
          _vm.newSelectedDriverInRow = $event
        }
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (order.voucher == null || order.voucher.length === 0) ? _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.openEditModal(order)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(order.price) + " RSD\n")]) : _vm._e(), (order.voucher != null && order.voucher.length > 0) ? _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.openEditModal(order)
        }
      }
    }, _vm._l((_vm.getVouchers(order.voucher)), function(obj) {
      return _c('span', [_vm._v("\n                                    " + _vm._s(obj.count) + "\n                                    "), (obj.voucher === 'VOUCHER_GREEN') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_BLUE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_blue.png")
        }
      }) : _vm._e(), _vm._v(" "), (obj.voucher === 'VOUCHER_WHITE') ? _c('img', {
        staticStyle: {
          "width": "20px",
          "height": "20px"
        },
        attrs: {
          "src": require("../../assets/img/coin_white.png")
        }
      }) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', [(_vm.isFirstTimeDelivery(order)) ? _c('i', {
      staticStyle: {
        "color": "green",
        "font-style": "italic",
        "font-size": "2.0vh"
      }
    }, [_c('b', [_vm._v("Prva dostava")]), _c('br')]) : _vm._e(), _vm._v(" "), (order.deliveryProblemNote != null) ? _c('i', {
      staticStyle: {
        "color": "red",
        "font-style": "italic",
        "font-size": "2.0vh"
      }
    }, [_c('b', [_vm._v(_vm._s(order.deliveryProblemNote))]), _c('br')]) : _vm._e(), _vm._v("\n                              " + _vm._s(order.comment) + " "), (order.customerPhoneNumber != null) ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.showPhoneNumber(order)
        }
      }
    }, [_c('i', {
      staticClass: "ti-mobile",
      staticStyle: {
        "color": "white"
      }
    })]) : _vm._e(), _vm._v(" "), (order != null && order.orderPrice != null && order.orderPrice > 0) ? _c('span', [_vm._v("Cena poruzbine " + _vm._s(order.orderPrice) + " RSD")]) : _vm._e()]), _vm._v(" "), _c('td', {
      style: (_vm.getStatusStyle(order))
    }, [_vm._v(_vm._s(_vm.translateState(order.status)) + _vm._s(order.deliveredTime != null && order.status === 'DELIVERED' ? ' (' + _vm.formatDateToTime(new Date(order.deliveredTime)) + ')' : '')), (order.status !== 'DELIVERED' && order.status !== 'REJECTED' && order.status !== 'REQUESTED') ? _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#2b542c",
        "color": "white"
      },
      on: {
        "click": function($event) {
          return _vm.finishOrder(order)
        }
      }
    }, [_c('i', {
      staticClass: "ti-check"
    })]) : _vm._e(), _vm._v(" "), (_vm.adminUsername === 'nikolaadmin') ? _c('br') : _vm._e(), (_vm.adminUsername === 'nikolaadmin') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'https://321poruci.com/#/tracking?orderId=' + order.id
      }
    }, [_vm._v("Prati")]) : _vm._e()]), _vm._v(" "), (_vm.tabIndex < 2 && order.status !== 'REQUESTED') ? _c('td', [(_vm.getCourierName(order) == null) ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Preporuka",
        "name": "Preporuka",
        "value": "Preporuka"
      },
      on: {
        "click": function($event) {
          return _vm.getRecommendation(order.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getCourierName(order) != null && order.status === 'ASSIGNED') ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#946d13"
      },
      attrs: {
        "type": "button",
        "placeholder": "Pošalji obaveštenje",
        "name": "Pošalji obaveštenje",
        "value": "Pošalji obaveštenje"
      },
      on: {
        "click": function($event) {
          return _vm.resendNotification(order)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), ((order.status !== 'REQUESTED') && _vm.isAdmin()) ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obrisi",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOrder(order)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (order.status === 'REQUESTED') ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#2b542c"
      },
      attrs: {
        "type": "button",
        "placeholder": "Prihvati",
        "name": "Prihvati",
        "value": "Prihvati"
      },
      on: {
        "click": function($event) {
          return _vm.acceptCompanyOrder(order)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (order.status === 'REQUESTED') ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Odbij",
        "name": "Odbij",
        "value": "Odbij"
      },
      on: {
        "click": function($event) {
          return _vm.declineCompanyOrder(order)
        }
      }
    })]) : _vm._e()])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('edit-order-modal', {
    attrs: {
      "show": _vm.openEditOrder,
      "order": _vm.orderToEdit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži samo novije dostave (poslednjih 30min)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox3"
    }
  }, [_vm._v("Prikaži samo zakasnele dostave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "1500px",
      "color": "white"
    }
  }, [_vm._v("Restoran")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1500px",
      "color": "white"
    }
  }, [_vm._v("Broj dostava")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v("kreditom")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d98e578!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/Orders.vue
// module id = 499
// module chunks = 1